import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const F = "'Plus Jakarta Sans',sans-serif";

export default function PrivacyPage({ onBack }) {
  const { isRTL } = useLanguage();

  const sections = [
    {
      title: '1. Information We Collect',
      body: 'We collect the following information when you register or use our Service: your name, email address, WhatsApp number (optional), hashed password, and usage data (essays submitted, sessions attended). We do not store essay text permanently unless you explicitly save it.',
    },
    {
      title: '2. How We Use Your Information',
      body: 'Your information is used to: provide and improve the Service, manage your account and subscription, schedule and confirm lessons, send important service notifications via WhatsApp, and generate anonymised usage statistics to improve our AI feedback.',
    },
    {
      title: '3. Data Storage & Security',
      body: 'Your data is stored securely using Supabase (a GDPR-compliant database provider). Passwords are stored as SHA-256 hashes — we never store plaintext passwords. We use industry-standard security practices to protect your data.',
    },
    {
      title: '4. Data Sharing',
      body: 'We do not sell, trade, or rent your personal information to third parties. Your data may be shared with: your assigned teacher (name and contact details only), and our AI provider (essay text for feedback generation — not stored permanently).',
    },
    {
      title: '5. AI Processing',
      body: 'Essays submitted for AI feedback are sent to our AI service provider for analysis. This data is processed in real-time and is not used to train AI models or stored by the provider beyond the immediate request.',
    },
    {
      title: '6. Your Rights',
      body: 'You have the right to: access the personal data we hold about you, request correction of inaccurate data, request deletion of your account and associated data, and withdraw consent at any time. To exercise these rights, contact Mr. Ahmed Salem on WhatsApp.',
    },
    {
      title: '7. Cookies & Local Storage',
      body: 'Our platform uses browser localStorage to store your session information and preferences (such as language choice). No third-party tracking cookies are used. You can clear your browser storage at any time.',
    },
    {
      title: '8. WhatsApp Communication',
      body: 'By providing your WhatsApp number, you consent to receiving lesson confirmations, reminders, and important account notifications via WhatsApp. You can opt out by contacting Mr. Ahmed Salem.',
    },
    {
      title: '9. Children\'s Privacy',
      body: 'Our Service is intended for users aged 13 and above. If you are under 18, please ensure a parent or guardian has reviewed these terms. We do not knowingly collect data from children under 13.',
    },
    {
      title: '10. Changes to This Policy',
      body: 'We may update this Privacy Policy from time to time. We will notify you of significant changes via WhatsApp or email. Continued use of the Service after changes constitutes acceptance.',
    },
    {
      title: '11. Contact',
      body: 'For privacy-related questions or to exercise your data rights, contact Mr. Ahmed Salem: WhatsApp +20 100 818 2425 or +971 56 572 7742.',
    },
  ];

  return (
    <div dir={isRTL?'rtl':'ltr'} style={{ minHeight:'100vh', background:'#f8f9fb', fontFamily:F }}>
      {/* Header */}
      <div style={{ background:'linear-gradient(135deg,#1a2a4a,#2a3a5a)', padding:'24px 24px 20px', color:'#fff' }}>
        <div style={{ maxWidth:700, margin:'0 auto' }}>
          <button onClick={onBack}
            style={{ background:'rgba(255,255,255,0.12)', border:'1px solid rgba(255,255,255,0.2)', color:'#fff', borderRadius:8, padding:'6px 14px', fontSize:12, cursor:'pointer', fontFamily:"'JetBrains Mono',monospace", letterSpacing:'.07em', marginBottom:16 }}>
            ← Back
          </button>
          <div style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:10, letterSpacing:'.2em', textTransform:'uppercase', color:'rgba(255,255,255,0.5)', marginBottom:6 }}>
            IELTS Compass
          </div>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:28, fontWeight:700 }}>
            Privacy Policy
          </div>
          <div style={{ fontSize:12, color:'rgba(255,255,255,0.6)', marginTop:6 }}>
            Last updated: May 2025
          </div>
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth:700, margin:'0 auto', padding:'32px 24px 60px' }}>
        {sections.map((s, i) => (
          <div key={i} style={{ marginBottom:28 }}>
            <div style={{ fontSize:15, fontWeight:700, color:'#1a2a4a', marginBottom:8 }}>{s.title}</div>
            <div style={{ fontSize:14, color:'#4a5a78', lineHeight:1.75 }}>{s.body}</div>
          </div>
        ))}

        <div style={{ borderTop:'1px solid #e8edf5', paddingTop:24, marginTop:8 }}>
          <div style={{ fontSize:13, color:'#9aa3b8', lineHeight:1.7 }}>
            This Privacy Policy applies to all users of the IELTS Compass platform and Compass Academy services, effective May 2025.
          </div>
        </div>
      </div>
    </div>
  );
}
